var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"width":"100%","height":"520px"},attrs:{"id":"reports"}},[_vm._v("加载中..")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }